import { ApiError } from "@/platform/api/errors"
import { REFERRAL_ERROR_CODES } from "@/platform/api/referrals"

const expectedCodes = new Set([
  ...Object.values(REFERRAL_ERROR_CODES),
  "marketplace.cart.discounts_invalidated",
  "marketplace.store_credit.insufficient",
  "validation.failed",
  "session_identity_changed",
  "marketplace.cart.mismatch",
  "marketplace.cart.stale_state",
  "marketplace.cart.invalid_state",
  "marketplace.cart.insufficient_inventory",
  "marketplace.checkout.missing_address",
  "marketplace.checkout.missing_shipping_methods",
])

const reported = new WeakSet<Error>()
const requestContext = new WeakMap<Error, Record<string, unknown>>()

export const isExpectedError = (error: unknown): boolean => {
  if (error instanceof Error) {
    if (error.name === "SupersededViewerError") return true
    if (error.name === "AbortError" || error.name === "CancelledError") return true
    if (error instanceof ApiError && error.code && (expectedCodes.has(error.code) || error.code.startsWith("marketplace.checkout.blocked_"))) return true
  }
  return false
}

export const errorFacts = (error: unknown): Record<string, unknown> => ({
  ...(error instanceof Error && error.name === "SupersededViewerError" && error.cause instanceof Error ? errorFacts(error.cause) : {}),
  ...(error instanceof ApiError ? { http_status: error.status, error_code: error.code, backend_trace_id: error.traceId } : {}),
  ...(error instanceof Error ? requestContext.get(error) : {}),
})

export const attachRequestContext = (error: unknown, context: Record<string, unknown>): void => {
  if (error instanceof Error) requestContext.set(error, { ...requestContext.get(error), ...context })
}

export const isReported = (error: unknown): boolean => error instanceof Error && reported.has(error)

export const claimError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return true
  if (reported.has(error)) return false
  reported.add(error)
  return true
}
